import React from 'react';

const MiniTvUiOverlayContext = React.createContext<React.RefObject<HTMLDivElement | null>>({ current: null });

export default MiniTvUiOverlayContext;
